<template>
  <div>
    <div class="row w-50">
      <div class="col">
        <base-input v-model="form.siteName"
                    label="Burn Site Name"
                    placeholder="Burn Site Name"
                    :validation="val.form.siteName" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col-8">
        <base-input v-model="form.crossStreets"
                    label="Main Cross Streets"
                    placeholder="Main Cross Streets"
                    :validation="val.form.crossStreets" />
      </div>
      <div class="col-4">
        <base-input v-model="form.siteCity"
                    label="Burn Site City"
                    placeholder="Burn Site City"
                    :validation="val.form.siteCity" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col">
        <base-input v-model="form.siteAddress"
                    label="Burn Site Address"
                    placeholder="Burn Site Address" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col">
        <base-input v-model="form.siteAddress2"
                    label="Burn Site Address 2"
                    placeholder="Burn Site Address 2" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col">
        <base-select v-model="form.siteState"
                     label="Burn Site State"
                     :options="formFieldData.states"
                     placeholder="Burn Site State" />
      </div>
      <div class="col">
        <base-input v-model="form.siteZip"
                    label="Burn Site Zip Code"
                    placeholder="Burn Site Zip Code"
                    mask="#####" />
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <base-date-picker v-model="form.dateOfBurn"
                          label="Date of Burn" />
      </div>
      <div class="col-4">
        <base-input v-model="form.totalHours"
                    label="Total Hours"
                    type="number"
                    max="24"
                    placeholder="Total Hours" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col-7">
        <base-input v-model="form.totalSessions"
                    label="How many burn sessions will be taking place? (max 10)"
                    placeholder="Total Sessions"
                    v-on:input="checkSessions"
                    :validation="val.form.totalSessions" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <yes-no v-model="form.moreThanDay"
                label="Is burn date over more than one day?" />
      </div>
    </div>
    <div class="row w-100" v-if="form.moreThanDay == true">
      <div class="col">
        <base-textarea v-model="form.otherDate"
                       label="Detail other dates and hours:"
                       :validation="val.form.otherDate" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col">
        <base-input v-model="form.contactFirstName"
                    label="On Site Contact First Name"
                    placeholder="On Site Contact First Name"
                    :validation="val.form.contactFirstName" />
      </div>
      <div class="col">
        <base-input v-model="form.contactLastName"
                    label="On Site Contact Last Name"
                    placeholder="On Site Contact Last Name"
                    :validation="val.form.contactLastName" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col">
        <base-input v-model="form.contactPhone"
                    label="On Site Contact Phone"
                    type="tel"
                    mask="(###)-###-####"
                    placeholder="(xxx)-xxx-xxxx"
                    :validation="val.form.contactPhone" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col">
        <p class="font-14">Specify total amounts of material to be burned at the site.  Include material(s) used to start the fire and any supplemental material(s) used to maintain the fire.  Describe items in appropriate terms, for example: </p>
        <ul>
          <li class="font-14">
            PRAIRIES: Acres – Type of extent of vegetation
          </li>
          <li class="font-14">
            CHEMICALS: Volume or weight – chemical constituents
          </li>
          <li class="font-14">
            BUILDINGS: Stories, rooms, square feet – type of construction, state of deterioration, roofing & siding materials, remaining furnishings and other contents
          </li>
        </ul>
      </div>
    </div>
    <div class="row w-75">
      <div class="b-bottom w-100" v-for="(item, index) in form.burnMaterials">
        <div class="col">
          <base-input v-model="item.name"
                      label="Material Name"
                      placeholder="Material Name"
                      :validation="val.form.burnMaterials.$each[index].name" />
        </div>
        <div class="col">
          <base-input v-model="item.amount"
                      label="Material Amount"
                      placeholder="Material Amount"
                      :validation="val.form.burnMaterials.$each[index].amount" />
        </div>
        <div class="col">
          <base-input v-model="item.description"
                      label="Material Description"
                      placeholder="Material Description"
                      :validation="val.form.burnMaterials.$each[index].description " />
        </div>
        <div class="col">
          <button v-if="index > 0" class="btn btn-danger" style="margin-bottom: 2%;"
                  @click="removeMaterial(index)">
            Remove
          </button>
        </div>
      </div>
    </div>
    <div class="row w-100">
      <div class="col">
        <button style="margin-bottom: 2%;" class="btn btn-primary"
                @click="addMaterial">
          Add Another Material
        </button>
      </div>
    </div>
    <div class="row w-100">
      <div class="col">
        <base-textarea v-model="form.methodOfExtinguishment"
                       label="Method of extinguishment"
                       :validation="val.form.methodOfExtinguishment" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <yes-no v-model="form.individualsNotifiedInd"
                label="Have individuals living or working near the site been notified of the proposed open burning?" />
      </div>
    </div>
    <div class="row w-100" v-if="form.individualsNotifiedInd">
      <div class="col">
        <base-input v-model="form.individualsNotifiedExplaination"
                    label="Explain method of notice and any additional measures to be taken to respond to concern"
                    placeholder="Explanation"
                    :validation="val.form.individualsNotifiedExplaination" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <yes-no v-model="form.isBurn100FeetAwayInd"
                label="Is burn 1000 feet from residence and businesses?" />
      </div>
    </div>
    <bottom-navigation link="certificationinfo">Certification Information</bottom-navigation>
  </div>
</template>

<script>
import BaseInput from '~/components/BaseInput';
import BaseSelect from '~/components/BaseSelect';
import VAddress from '~/components/VAddress';
import BaseDatePicker from '~/components/BaseDatePicker';
import YesNo from '~/components/YesNo';
import BaseTextarea from '~/components/BaseTexarea';
import BottomNavigation from '~/components/BottomNavigation';
import { OpenBurnFormData } from '../../../js/FormObjects';


export default {
  name: 'BurnInfo',
  props: ['form', 'val'],
  components: {
    BaseInput, VAddress, BaseDatePicker, YesNo, BaseTextarea, BaseSelect, BottomNavigation,
  },
  data() {
    return {
      registerUrl: '',
      loginUrl: '',
      formFieldData: new OpenBurnFormData(),
    };
  },
  mounted() {

  },

  methods: {
    addMaterial() {
      this.$props.form.burnMaterials.push({ name: null, amount: null, description: null });
    },
    removeMaterial(index) {
      this.$props.form.burnMaterials.splice(index, 1);
    },
    checkSessions() {
      const lastChar = this.$props.form.totalSessions.substr(this.$props.form.totalSessions.length - 1);
      if (lastChar == '.' || lastChar == '-') {
        this.$props.form.totalSessions = this.$props.form.totalSessions.substr(0, this.$props.form.totalSessions.length - 1);
      }
    },
  },
};

</script>
